"use client";

import { ComponentInfo } from "@builder.io/sdk-react";

export const PRODUCT_SPECIFICATION_INPUTS = [
  {
    name: "customAttributes",
    type: "list",
    subFields: [
      {
        name: "label",
        type: "string",
        defaultValue: "",
      },
      {
        name: "values",
        type: "list",
        subFields: [
          {
            name: "value",
            type: "string",
            defaultValue: "",
          },
        ],
        defaultValue: [],
      },
    ],
    defaultValue: [],
  },
] as const satisfies ComponentInfo["inputs"];

export type ProductSpecificationProps = BuilderComponentProps<
  typeof PRODUCT_SPECIFICATION_INPUTS
>;
